import React from "react"

import { AnimatedModal } from "../../shared/Modal"

const ConfirmMissingPhoneModal = ({ visible, hideModal, onSave, onRemind, client, disabled, reminding }) => {
  const clientName = client?.firstName || "This client"

  return (
    <AnimatedModal
      visible={visible}
      hideModal={hideModal}
      header="No phone on file"
      showFooter={true}
      actionButtonCopy="Continue & book"
      actionButtonDataTestid="confirm-missing-phone-continue"
      saveDisabled={disabled || reminding}
      onSave={onSave}>
      <p className="mb-4">
        {clientName} doesn&apos;t have a phone number on file. You can still book, or send a reminder so they can add
        one.
      </p>
      {onRemind && (
        <button
          type="button"
          className="font-bold text-teal hover:underline disabled:opacity-50"
          disabled={reminding || !client?.email}
          onClick={onRemind}>
          {reminding ? "Sending…" : "Remind to add phone"}
        </button>
      )}
    </AnimatedModal>
  )
}

export default ConfirmMissingPhoneModal
